module.exports = __webpack_public_path__ + "img/vertical_6_6_6000.c5233897.png";